import { useState } from "react";
import { Input } from "shared/ui/Input";
import { PasswordInput } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { useHttpRequest } from "shared/lib/hooks/useHttpRequest";
import { registrationRequest } from "features/login/api/registrationRequest";
import {
  validateIndividualForm,
  individualValidateOnBlur,
  individualClearOnChange,
} from "../../lib/register-validation/individualValidation";
import { useFormValidation } from "../../lib/register-validation/common";
import { SopdAgreement } from "../agreement/ui/SopdAgreement";
import styles from "../FormStyles.module.scss";

export const RegistrationIndividualForm = ({ onSuccess }) => {
  const [agreement, setAgreement] = useState({
    checked: false,
    checkedAt: "",
  });

  const [serverError, setServerError] = useState("");

  const handleAgreementChange = ({ checked, checkedAt }) => {
    setAgreement({ checked, checkedAt });
  };

  const { sendRequest, loading, error, clearError } =
    useHttpRequest(registrationRequest);

  const {
    formData,
    fieldErrors,
    errorMessages,
    requiredFieldsError,
    handleInputChange,
    handleBlur,
    validateForm,
  } = useFormValidation(
    {
      //TODO Надо стрипать fio при отправке
      fio: "",
      phoneNumber: "",
      email: "",
      password: "",
      confirmedPassword: "",
    },
    {
      validate: validateIndividualForm,
      validateOnBlur: individualValidateOnBlur,
      clearOnChange: individualClearOnChange,
    },
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { isValid, requiredFieldsError: requiredError } = validateForm();

    if (!isValid || loading) return;

    setServerError("");

    const submitData = {
      phoneNumber: formData.phoneNumber,
      email: formData.email,
      fio: formData.fio.trim(),
      password: formData.password,
      agreementSOPD: {
        agreementStatus: agreement.checked,
        date: agreement.checkedAt,
      },
    };

    try {
      await sendRequest(submitData);
      onSuccess?.(formData.email);
    } catch (error) {
      const status = error?.status;

      if (status === 401) {
        return;
      }

      if (error?.status === 409) {
        setServerError(
          error?.data?.detail ||
            error?.data?.message ||
            error?.message ||
            "Произошла ошибка, попробуйте позже",
        );
        return;
      }

      if (status >= 500) {
        return;
      }
      setServerError("Произошла ошибка, попробуйте позже");
    }
  };

  return (
    <form className={styles.formWrapper}>
      <div className={styles.formWrapper__form}>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>ФИО</p>
          <Input
            type="text"
            value={formData.fio}
            onChange={(e) => handleInputChange("fio", e.target.value)}
            onBlur={(e) => handleBlur("fio", e.target.value)}
            placeholder="Введите ФИО"
            className={`${fieldErrors.fio ? styles.formWrapper__inputError : styles.formWrapper__input}`}
          />
          {errorMessages.fio && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.fio}
            </span>
          )}
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Номер телефона</p>
          <Input
            type="text"
            value={formData.phoneNumber}
            onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
            onBlur={(e) => handleBlur("phoneNumber", e.target.value)}
            placeholder="+7"
            className={`${fieldErrors.phoneNumber ? styles.formWrapper__inputError : styles.formWrapper__input}`}
            mask="+7 (___) ___-__-__"
            replacement={{ _: /\d/ }}
          />
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Электронная почта</p>
          <Input
            type="text"
            value={formData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            onBlur={(e) => handleBlur("email", e.target.value)}
            placeholder="example@mail.ru"
            autoComplete="username"
            className={`${fieldErrors.email ? styles.formWrapper__inputError : styles.formWrapper__input}`}
          />
          {errorMessages.email && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.email}
            </span>
          )}
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Пароль</p>
          <PasswordInput
            value={formData.password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            onBlur={(e) => handleBlur("password", e.target.value)}
            placeholder="Введите пароль"
            autoComplete="new-password"
            className={`${fieldErrors.password ? styles.formWrapper__inputError : styles.formWrapper__input} ${styles.formWrapper__passwordBtn}`}
          />
          {errorMessages.password && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.password}
            </span>
          )}
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Повторите пароль</p>
          <PasswordInput
            value={formData.confirmedPassword}
            onChange={(e) =>
              handleInputChange("confirmedPassword", e.target.value)
            }
            onBlur={(e) => handleBlur("confirmedPassword", e.target.value)}
            placeholder="Введите пароль"
            autoComplete="new-password"
            className={`${fieldErrors.confirmedPassword ? styles.formWrapper__inputError : styles.formWrapper__input} ${styles.formWrapper__passwordBtn}`}
          />
          {errorMessages.confirmedPassword && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.confirmedPassword}
            </span>
          )}
        </div>

        {requiredFieldsError && (
          <span className={styles.formWrapper__greenText}>
            {requiredFieldsError}
          </span>
        )}

        {serverError && (
          <span className={styles.formWrapper__greenText}>{serverError}</span>
        )}

        <div>
          <SopdAgreement
            checked={agreement.checked}
            onChange={handleAgreementChange}
          />
        </div>
      </div>

      <div className={styles.formWrapper__buttonBlock}>
        <div className={styles.formWrapper__button}>
          <Button
            variant={agreement.checked ? "primary" : "disabled"}
            size="large"
            onClick={handleSubmit}
            type="submit"
            disabled={!agreement.checked}
          >
            Зарегистрироваться
          </Button>
        </div>
      </div>
    </form>
  );
};
